'use client';
import { RefObject } from 'react';

interface VideoPlayerProps {
  containerRef: RefObject<HTMLDivElement | null>;
  onToggle: () => void;
  enableClickHandler?: boolean;
}

export function VideoPlayer({ containerRef, onToggle, enableClickHandler = true }: VideoPlayerProps) {
  return (
    <div
      ref={containerRef}
      className="absolute inset-0 w-full h-full overflow-hidden z-10"
      onClick={enableClickHandler ? onToggle : undefined}
    />
  );
}
